import service from "../config";

export function jobCategory() {
  return service({
    url: "/apply/job/category",
    method: "get",
  });
}

export function jobCategoryList(categoryName: string) {
  return service({
    url: "/apply/jobs",
    method: "get",
    params: {
      category: categoryName,
      property: 1
    },
  });
}

export function jobCategoryListSearch(categoryName: string, pageNum: number, property: any) {
  return service({
    url: "/apply/jobs",
    method: "get",
    params: {
      category: categoryName,
      pageNum,
      pageSize: 8,
      property
    },
  });
}

// 根据关键字搜索职位
export function jobSearch(position: string, pageNum: number, property: any) {
  return service({
    url: "/apply/job",
    method: "get",
    params: { 
      pageNum,
      pageSize: 8,
      position,
      property
    },
  });
}

export function jobDetail(jobCode: string) {
  return service({
    url: "/apply/job/details",
    method: "get",
    params: { jobCode },
  });
}

export function isJobApply(jobCode: string) {
  return service({
    url: "/apply/resume/isApply",
    method: "get",
    params: { jobCode },
  });
}
